export enum TooltipPosition {
    right = 'right',
    left = 'left'
  }